import * as types from '../types/MyApplications';

export const myApplicationsRequest = payload => ({
    type: types.MY_APPLICATIONS_REQUSET,
    payload
})
export const myApplicationsReceive = payload => ({
    type: types.MY_APPLICATIONS_RECIEVE,
    payload
})